'use strict';

const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

function getMonthIndex(month) {
    const normalizedMonth = String(month || '').slice(0, 3).toLowerCase();
    return MONTHS.map((value) => value.toLowerCase()).indexOf(normalizedMonth);
}

function normalizeYearlyMonths(rows, valueKey) {
    const values = new Array(12).fill(0);

    (rows || []).forEach((row) => {
        const monthIndex = getMonthIndex(row.Months);
        if (monthIndex >= 0) {
            values[monthIndex] = Number(row[valueKey]) || 0;
        }
    });

    return MONTHS.map((month, index) => [month, values[index]]);
}

function calculateMonthlyOee(rows) {
    const totals = new Array(12).fill(0);
    const counts = new Array(12).fill(0);

    (rows || []).forEach((row) => {
        const monthIndex = getMonthIndex(row.Months);
        const value = Number(row.avgMc) || 0;

        if (monthIndex >= 0 && value > 0) {
            totals[monthIndex] += value;
            counts[monthIndex] += 1;
        }
    });

    return MONTHS.map((month, index) => [
        month,
        counts[index] > 0 ? Number((totals[index] / counts[index]).toFixed(1)) : 0,
    ]);
}

module.exports = {
    calculateMonthlyOee,
    normalizeYearlyMonths,
};
